<template>
    <div v-if="useUserStore().user?.id">
        <button
            class="nav-link nav-profile dropdown-toggle has-dark"
            id="profileMenuDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
        >
            {{$t('Account')}}
        </button>
        <div
            class="dropdown-menu dropdown-menu-end"
            aria-labelledby="profileMenuDropdown"
        >
            <NuxtLink
                v-for="menuItem in useMenuStore().profile"
                :key="menuItem.url"
                class="dropdown-item d-flex justify-items-center py-2"
                :class="{ active: menuItem.active, [menuItem.class]: menuItem.class }"
                :target="menuItem.target ? menuItem.target : undefined"
                :to="menuItem.url"
            >
                {{ menuItem.name }}
                <img
                    v-if="menuItem.icon"
                    class="ms-auto"
                    :src="menuItem.icon"
                    :alt="menuItem.name"
                />
            </NuxtLink>
        </div>
    </div>
    <LoginButton v-else/>
</template>

<script setup>
import {useMenuStore} from "~/stores/MenuStore";
const LoginButton = defineAsyncComponent(() => import("~/components/Auth/LoginButton.vue"));
</script>
